export var CellStatus;
(function (CellStatus) {
    CellStatus["Unknown"] = "REGISTRATION_UNKNOWN";
    CellStatus["Searching"] = "NOT_REGISTERED_SEARCHING";
    CellStatus["Home"] = "REGISTERED_HOME";
    CellStatus["Roaming"] = "REGISTERED_ROAMING";
    CellStatus["Idle"] = "NOT_REGISTERED_IDLE";
    CellStatus["Denied"] = "REGISTRATION_DENIED";
    CellStatus["SIMError"] = "NOT_REGISTERED_SIM_ERROR";
})(CellStatus || (CellStatus = {}));
//# sourceMappingURL=device-state.js.map